import Vue from 'vue'
import Router from 'vue-router'
import CityPopularRanking from '@/page/cityPopularRanking'
import RulePage from '@/page/rule'
import RankItem from '@/page/RankItem'
import CityHotNewsRanking from '@/page/cityHotNewsRanking'

Vue.use(Router)

export default new Router({
  mode:"hash",
  routes: [
    {
      path: '/cityPopularRanking', //人气榜
      component: CityPopularRanking
    },
    {
      path: '/rule',
      component: RulePage
    },
    {
      path: '/rankitem',
      component: RankItem
    },
    {
      path: '/cityHotNewsRanking',  //热文榜
      component: CityHotNewsRanking
    },
    {
      path: '*',
      component: CityPopularRanking
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js